<template>
  <layout-form v-if="data != null">
    <template v-slot:Title><span class="spacing-playground pa-6"></span>
      <v-divider vertical></v-divider><span class="spacing-playground pa-6"> </span>
      <v-toolbar-title><span class="title indigo--text"> {{ eventname }} </span>
      </v-toolbar-title>
    </template>
    <template v-slot:Main>
      <v-parallax dark :src="data.images.head || tmp" height="350">
        <v-row align="center" justify="center">
          <v-col class="text-center" cols="12">
            <h1 class="text-h4 font-weight-thin mb-4 font-weight-bold">
              {{ eventname }}
            </h1>
            <h4 class="subheading">
              {{ data.eventtime }}
            </h4>
            <br />
            <div class="font-weight-regular text-center" style="padding-left: 20%; padding-right: 20%">
              <span class="pa-4" /> <span> {{ description }}</span>
            </div>
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-spacer />
          <v-col align="center" cols="12">
            <v-btn outlined large dark @click="regis" v-if="!isExpired"> Register </v-btn>
            <h3 v-else > This event is now closed for registration.</h3>
          </v-col>
        </v-row>
      </v-parallax>
      <v-img :src="data.images.edm" />
    </template>
  </layout-form>
  <div v-else-if="onload">
    <v-overlay :opacity="1" :value="onload">
      <v-progress-circular indeterminate size="64">
        Loading...
      </v-progress-circular>
    </v-overlay>
  </div>
  <not-found v-else />
</template>

<script>
import NotFound from "@/components/404.vue";
import layoutForm from "@/layouts/main.vue";

const API = process.env.VUE_APP_API;
// import event from "@/Mockup/event.json";

export default {
  name: "Home",
  components: {
    layoutForm,
    NotFound,
  },
  data() {
    return {
      data: null,
      eventname: "",
      description: "",
      onload: false,
      tmp: require(`@/assets/xxx.jpg`),
      isExpired:false
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async getEvent() {
      this.onload = true;
      try {
        let rest = await axios.get(`${API}/event`);
        this.onload = false;
        return rest.data;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    regis() {
      this.$router.push({
        name: "Regis",
        params: { id: this.$route.params.id },
      });
    },
    async init() {
      this.onload = true;
      let rest = await this.getEvent();
      rest = rest.filter((e) => e.uuid == this.$route.params.id);
      if (rest.length > 0) {
        if (rest[0].RegisExpired) {
          let xNow = new Date()
          xNow.setHours(0,0,0,0);
          let RegisExpired = new Date(rest[0].RegisExpired)
          RegisExpired.setHours(0,0,0,0);
          if(xNow>RegisExpired) this.isExpired=true 
          // console.log(xNow,RegisExpired,this.isExpired)
        }

        this.data = rest[0];
      }

      //if (!this.data.head) this.data.head = require(`@/assets/xxx.jpg`);
      this.eventname = this.data.eventname;
      this.description = this.data.descption || " ";
      this.onload = false;
    },
  },
};
</script>
